import { logger } from 'features/logger/logger';
import { rememberLastBrand } from './brandCache';
import { brandForPath } from './brandForPath';
import type { CachedBrand } from './brandCache';
import type { BrandFile } from '@hub/common';

type SetActiveBrand = (brand: BrandFile | undefined) => void;

// Applies a loaded brand, or none, and remembers it as the last brand of
// `details.protocolId`; a failure logs a warning. Nothing applies once
// `signal` aborts.
export const applyLoadedBrand = (
  loading: Promise<CachedBrand | null>,
  signal: AbortSignal,
  setActiveBrand: SetActiveBrand,
  details: { protocolId: string; url?: string }
): Promise<void> =>
  loading
    .then(brand => {
      if (signal.aborted) return;
      rememberLastBrand(details.protocolId, brand?.pointer ?? null);
      setActiveBrand(brand?.file);
    })
    .catch((error: unknown) => {
      if (!signal.aborted)
        logger.warn('Unable to load the protocol brand', {
          details: { ...details, error },
        });
    });

// Applies the brand of the current address (`brandForPath`).
export const applyBrandForPath = (setActiveBrand: SetActiveBrand) => {
  setActiveBrand(brandForPath(window.location.pathname));
};
